"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var _span;
var setFont = function setFont(language) {
  if (language !== '') {
    return {
      fontFamily: "'MMC-Regular-" + language.toUpperCase() + "', 'MMC-Regular-DEFAULT', 'MMC-Medium', Arial, Helvetica, Verdana, sans-serif"
    };
  }
  return {};
};
var ToolTip = function ToolTip(_ref) {
  var toolTipMessage = _ref.toolTipMessage,
    toolTipLanguage = _ref.toolTipLanguage,
    theme = _ref.theme,
    setCookie = _ref.setCookie,
    mobileNavActive = _ref.mobileNavActive,
    _ref$config = _ref.config,
    languageDirectionMap = _ref$config.languageDirectionMap,
    language = _ref$config.language;
  var languageDirectionData = toolTipLanguage !== '' ? languageDirectionMap.find(function (langData) {
    return langData.language === toolTipLanguage;
  }) : languageDirectionMap.find(function (langData) {
    return langData.language === language;
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].toolTip + " " + (mobileNavActive === true ? _navigationHeader["default"].isMobileNav : ''),
    style: {
      top: 110
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].textLogoContainer,
    dir: languageDirectionData.direction
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _navigationHeader["default"].languageToolTipIcon
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _navigationHeader["default"].toolTipText + " " + theme.richTextPassThrough + " " + theme.tabActive,
    style: setFont(toolTipLanguage)
  }, toolTipMessage)), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: _navigationHeader["default"].dismissButton,
    onClick: setCookie
  }, _span || (_span = /*#__PURE__*/_react["default"].createElement("span", null, "dismiss"))));
};
ToolTip.defaultProps = {
  toolTipMessage: '',
  toolTipLanguage: '',
  mobileNavActive: false,
  setCookie: function setCookie() {
    return null;
  },
  theme: {}
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(ToolTip);